module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading m-t-4 m-b-4"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row p-t-4 recomendations"
  }, [_c('h1', {
    staticClass: "m-b-3"
  }, [_vm._v(_vm._s(_vm.t('Search by regions')))]), _vm._v(" "), _vm._l((_vm.recomendations), function(recomendation) {
    return _c('div', {
      staticClass: "col-md-4 m-b-2 recomendation"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + _vm.language + "/search?location=" + (recomendation.location_id) + "&startDate=" + _vm.startDate + "&endDate=" + _vm.endDate)
      }
    }, [_c('Card', [_c('div', {
      slot: "image"
    }, [_c('img', {
      attrs: {
        "src": recomendation.image.data.thumbnail_path,
        "alt": recomendation.image.data.locale[_vm.language].name
      }
    })]), _vm._v(" "), _c('div', {
      slot: "title"
    }, [_vm._v("\n        " + _vm._s(recomendation.translations[_vm.language].name) + "\n      ")]), _vm._v(" "), _c('div', {
      slot: "content"
    }, [_vm._v("\n        " + _vm._s(recomendation.translations[_vm.language].description) + "\n      ")])])], 1)], 1)
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fbb2b198", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbb2b198"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/SearchLinks.vue
// module id = 810
// module chunks = 3